import {
  DELETE_GROUP,
  DELETE_GROUP_FAILED,
  DELETE_GROUP_SUCCESS,
  DELETE_GROUP_RESET,
} from "../actions/action_deleteGroup";

const initialState = {
  error: null,
  data: null,
  loading: null,
  initial: true,
};

const deleteGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_GROUP:
      return {
        ...state,
        data: null,
        error: null,
        loading: true,
        initial: false,
      };
    case DELETE_GROUP_FAILED:
      return {
        ...state,
        data: null,
        error: action.payload,
        loading: false,
        initial: false,
      };
    case DELETE_GROUP_SUCCESS:
      return {
        ...state,
        data: action.payload,
        error: null,
        loading: false,
        initial: false,
      };
    case DELETE_GROUP_RESET:
      return initialState;
    default:
      return state;
  }
};

export default deleteGroupReducer;
